(function ($) {
    $.ajax({
        type: 'GET',
        url: 'https://graph.facebook.com/v17.0/17841402010516056?access_token=EAALMEKrxpfoBALBJHa7FlX7M7KMNtdeS6N36mpwCznZB93ljuRXPVJ9JcEuCM9RGfMC9C3r0v6m9XQOZB8MfpOgx03FFkD0yZAVy3haE1259mDZCrUHZBgedGNYrbUOa4895moZAQ4jUF9QwU5EiWhUkXX03KhTGN722StORk6WoKmHAZC5Uzdx&fields=name,media{caption,like_count,media_url,permalink,timestamp,username}',
        dataType: 'json',
        success: function (json) {
            var insta = json.media.data;
            for (var i = 0; i < 4; i++) {
              console.log(i)
              var url = insta[i].media_url; // 動画ソースのURLを取得
              var href = insta[i].permalink; // リンク先URLを取得
              var caption = insta[i].caption; //　投稿のキャプションを取得
              if(url.indexOf('.mp4') <= 0){
                $('.insta_list').append(`
<li>
  <a href="${href}" target="qoo_insta">
    <img src="${url}" alt="${caption}">
  </a>
</li>
              `);
}
            }
        }
    });
})(jQuery);